module.exports = __webpack_public_path__ + "static/media/r37.4a8ee541.jpg";